/**
 * @generated SignedSource<<65ec24193a08f332913fca066161a00b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserProfilePreviewRelayContent_workedOn$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly object: {
        readonly data: {
          readonly __typename: "AssetsObject";
          readonly links: {
            readonly web: string | null;
          } | null;
        } | {
          readonly __typename: "AssetsObjectType";
          readonly links: {
            readonly web: string | null;
          } | null;
        } | {
          readonly __typename: "AssetsSchema";
          readonly links: {
            readonly web: string | null;
          } | null;
        } | {
          readonly __typename: "BitbucketPullRequest";
          readonly href: AGG$URL | null;
        } | {
          readonly __typename: "CompassComponent";
          readonly url: string | null;
        } | {
          readonly __typename: "ConfluenceBlogPost";
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluenceDatabase";
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluenceEmbed";
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluenceFooterComment";
          readonly container: {
            readonly __typename: "ConfluenceBlogPost";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            readonly __typename: "ConfluencePage";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            readonly __typename: "ConfluenceWhiteboard";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluenceInlineComment";
          readonly container: {
            readonly __typename: "ConfluenceBlogPost";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            readonly __typename: "ConfluencePage";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            readonly __typename: "ConfluenceWhiteboard";
            readonly links: {
              readonly base: string | null;
              readonly webUi: string | null;
            } | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluencePage";
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "ConfluenceWhiteboard";
          readonly links: {
            readonly base: string | null;
            readonly webUi: string | null;
          } | null;
        } | {
          readonly __typename: "DevOpsDesign";
          readonly webUrl: AGG$URL | null;
        } | {
          readonly __typename: "DevOpsDocument";
          readonly webUrl: AGG$URL | null;
        } | {
          readonly __typename: "DevOpsPullRequestDetails";
          readonly url: string | null;
        } | {
          readonly __typename: "ExternalDocument";
          readonly url: string | null;
        } | {
          readonly __typename: "ExternalPullRequest";
          readonly url: string | null;
        } | {
          readonly __typename: "ExternalRemoteLink";
          readonly url: string | null;
        } | {
          readonly __typename: "JiraIssue";
          readonly webUrl: AGG$URL | null;
        } | {
          readonly __typename: "JiraPlatformComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null;
          } | null;
          readonly webUrl: AGG$URL | null;
        } | {
          readonly __typename: "JiraServiceManagementComment";
          readonly issue: {
            readonly webUrl: AGG$URL | null;
          } | null;
          readonly webUrl: AGG$URL | null;
        } | {
          readonly __typename: "LoomVideo";
          readonly loomUrl: string;
        } | {
          readonly __typename: "MercuryFocusArea";
          readonly url: string | null;
        } | {
          readonly __typename: "MercuryPortfolio";
          readonly url: string | null;
        } | {
          readonly __typename: "RadarPosition";
          readonly url: string | null;
        } | {
          readonly __typename: "RadarView";
          readonly url: string | null;
        } | {
          readonly __typename: "TownsquareComment";
          readonly url: string | null;
        } | {
          readonly __typename: "TownsquareGoal";
          readonly url: string | null;
        } | {
          readonly __typename: "TownsquareProject";
          readonly url: string | null;
        } | {
          readonly __typename: "TrelloBoard";
          readonly trelloUrl: AGG$URL | null;
        } | {
          readonly __typename: "TrelloCard";
          readonly trelloUrl: AGG$URL | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null;
      };
    };
  }>;
  readonly " $fragmentType": "UserProfilePreviewRelayContent_workedOn";
};
export type UserProfilePreviewRelayContent_workedOn$key = {
  readonly " $data"?: UserProfilePreviewRelayContent_workedOn$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfilePreviewRelayContent_workedOn">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v1/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v1/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v1/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v5 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ]
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "url"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v8 = [
  (v7/*: any*/)
],
v9 = [
  (v7/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v8/*: any*/)
  }
],
v10 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v11 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v12 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "UserProfilePreviewRelayContent_workedOn",
  "selections": [
    {
      "concreteType": "ActivityItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "ActivityNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "ActivityObject",
              "kind": "LinkedField",
              "name": "object",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "data",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceDatabaseLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v1/*: any*/)
                        }
                      ],
                      "type": "ConfluenceDatabase"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "ConfluenceEmbedLinks",
                          "kind": "LinkedField",
                          "name": "links",
                          "plural": false,
                          "selections": (v1/*: any*/)
                        }
                      ],
                      "type": "ConfluenceEmbed"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v5/*: any*/),
                      "type": "ConfluenceFooterComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v5/*: any*/),
                      "type": "ConfluenceInlineComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "TownsquareGoal"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "TownsquareProject"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "TownsquareComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v8/*: any*/),
                      "type": "JiraIssue"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v9/*: any*/),
                      "type": "JiraPlatformComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v9/*: any*/),
                      "type": "JiraServiceManagementComment"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v10/*: any*/),
                      "type": "TrelloBoard"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v10/*: any*/),
                      "type": "TrelloCard"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v11/*: any*/),
                      "type": "DevOpsDocument"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "ExternalDocument"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "DevOpsPullRequestDetails"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "ExternalPullRequest"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v11/*: any*/),
                      "type": "DevOpsDesign"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "ExternalRemoteLink"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "MercuryFocusArea"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "MercuryPortfolio"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "RadarPosition"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "RadarView"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v6/*: any*/),
                      "type": "CompassComponent"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "href"
                        }
                      ],
                      "type": "BitbucketPullRequest"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": "loomUrl",
                          "kind": "ScalarField",
                          "name": "url"
                        }
                      ],
                      "type": "LoomVideo"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v12/*: any*/),
                      "type": "AssetsObject"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v12/*: any*/),
                      "type": "AssetsObjectType"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v12/*: any*/),
                      "type": "AssetsSchema"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "ActivityConnection"
};
})();

(node as any).hash = "0dbd90a8e3574e01182b84c062a6ad06";

export default node;
